// src/components/ExerciseListPanel.js
import { FiCheck as CheckIcon, FiStar as StarIcon } from "react-icons/fi";
import { FaStar as StarIconFilled } from "react-icons/fa";

import ListComponent from "./ListComponent";
import "./WorkoutList.css";

export default function ExerciseListPanel(props) {
  const {
    exercises = [],
    muscleGroups = [],
    subtitleForExercise,
  } = props;

  return (
    <ListComponent
      {...props}
      items={exercises}
      enableGroupFilter
      groups={muscleGroups}
      groupForItem={(e) => String(e?.muscleGroup?.group || "").trim()}
      getId={(e) => e.id}
      getTitle={(e) => e.name}
      subtitleForItem={(e) =>
        typeof subtitleForExercise === "function"
          ? subtitleForExercise(e)
          : e?.muscleGroup?.name
          ? `· ${e.muscleGroup.name}`
          : ""
      }
      MarkIcon={CheckIcon}
      FavIcon={StarIcon}
      FavIconFilled={StarIconFilled}
    />
  );
}